import ShareMemory from '../../features/parentcounsellor/ShareMemory'

const ShareMemoryPage = () => {
    return (
        <ShareMemory />
    )
}

export default ShareMemoryPage